import { useNavigate } from "react-router-dom";

import { routes } from "@/common/utils/routes";
import { nFormatter } from "@/common/utils/parseNumber";
import { INichesItems } from "@/common/services/types";
import DefaultUserIcon from "@/common/images/icons/default_userpic.svg?react";
import ArrowIcon from "@/common/images/icons/arrow_top_right.svg?react";

import "./SearchNiche.scss";

interface IProps {
  itemData: INichesItems;
  onClick: (value: string) => void;
}

export const SearchNiche = ({ itemData, onClick }: IProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    onClick(itemData.text);
    navigate(routes.niche(itemData.id));
  };

  return (
    <li className="SearchNiche" onClick={handleClick}>
      {
        itemData.image ?
          <div className="SearchNiche-NicheIcon" style={{ backgroundImage: `url(${itemData.image})` }} />
          : <div className="SearchNiche-NicheIcon SearchNiche-NicheIcon_isEmpty"><DefaultUserIcon /></div>
      }

      <div className="SearchNiche-Cnt">
        <h4>{itemData.text}</h4>
        <p>Niche | {nFormatter(itemData.subscribers)} members</p>
      </div>

      <ArrowIcon className="SearchNiche-Arrow" />
    </li>
  );
};
